import { call, put, select } from 'redux-saga/effects';

import { updateCarInstanceCustomer } from 'data-providers/carInstanceProvider';
import * as CarInstanceActions from 'store/carInstance/actions';
import * as CarInstanceSelectors from 'store/carInstance/selectors';
import { selectWhen } from 'store/helpers';

import * as InsuranceConstants from '../../constants';
import { CreateStage } from '../../helpers';

export const insuranceStageUpdateCarInstance = new CreateStage({
  action: InsuranceConstants.ACTIONS.UPDATE_CAR_INSTANCE,
  handler: function* () {
    // Ждем когда car instance заполнится
    yield selectWhen(CarInstanceSelectors.selectFetch, false);
    const carInstance = yield select(CarInstanceSelectors.selectValues);

    const response = yield call(updateCarInstanceCustomer, { carInstance });

    yield put(CarInstanceActions.setCarInstance(response));
  },
  name: InsuranceConstants.STAGES_FIELDS.UPDATE_CAR_INSTANCE,
}).watcher;
